/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { productsCreate } from "../../funcs/productsCreate.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.CreateProductRequest$inboundSchema,
};

export const tool$productsCreate: ToolDefinition<typeof args> = {
  name: "products-create",
  description: `Creates a new product for the specified account.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await productsCreate(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value.result;

    return formatResult(value, apiCall);
  },
};
